import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { FlexElementDirective } from './flex-element.directive';

@Directive({
  selector: '[layout]',
  standalone: true
})
export class FlexLayoutDirective extends FlexElementDirective implements OnInit {
  @Input()
  @HostBinding(`style.flex-direction`)
  layout: 'row' | 'column';

  @HostBinding(`style.display`)
  private flexDisplay = 'flex';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.setLayout();
  }

  private setLayout() {
    this.setStyle();
  }
}
